module.exports = __webpack_public_path__ + "static/media/Q.e3247dc2.png";